export default __webpack_public_path__ + "static/media/openhat.482e5231.wav";